<template>
  <a-table :columns="columns" :data-source="data" bordered :style="{background:'url('+imagePath+')'}">
    <template slot="fbillno" slot-scope="text">
      <a
        v-on:click="redirect('http://www.tcnanhua.com:5555/ui/examineDetail?fbillno='+text+'&fcheckername='+checkerName)">{{
          text
        }}</a>
    </template>
  </a-table>
</template>

<script>
import axios from 'axios';

export default {
  name: "examine",
  data() {
    return {
      imagePath: require('../assets/bj7.jpg'),
      data: [],
      checkerName: "",
      loading: false,
      columns: [
        {
          title: '单据编号',
          dataIndex: 'fbillno',
          scopedSlots: {customRender: 'fbillno'},
        },
        {
          title: '客户代码',
          dataIndex: 'fcusno',
        },
        {
          title: '客户名称',
          dataIndex: 'fcusname',
        },
        {
          title: '标题',
          dataIndex: 'ftitle',
        },
      ],
    };
  },
  methods: {
    redirect(url) {
      window.location.href = url;
    }
  },
  mounted() {
    this.loading = true;
    axios.get("http://www.tcnanhua.com:5555/user/getUserName?code=" + this.$route.query.code).then((res) => {
      this.checkerName = res.data.data;
      axios.get("http://www.tcnanhua.com:5555/t-sal-order/selectTSalOrder?fcheckername=" + this.checkerName)
        .then((resp) => {
          this.data = resp.data.data;
          this.loading = false;
        })
    });

  },
};
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Examine.vue